export enum HierarchicalLevelEnum {
  ALL_STAFF = "ALL_STAFF",
  OFFICE = "OFFICE",
  MIDDLE_MANAGEMENT = "MIDDLE_MANAGEMENT",
  FIELD_TECHNICIANS = "FIELD_TECHNICIANS",
}

export const getHierarchicalLevelLabel = (hierarchicalLevel: HierarchicalLevelEnum): string => {
  switch (hierarchicalLevel) {
    case HierarchicalLevelEnum.ALL_STAFF:
      return "Toda la plantilla";
    case HierarchicalLevelEnum.OFFICE:
      return "Oficina";
    case HierarchicalLevelEnum.MIDDLE_MANAGEMENT:
      return "Mandos intermedios";
    case HierarchicalLevelEnum.FIELD_TECHNICIANS:
      return "Técnicos con acceso a campo";
  }
};

export const getHierarchicalLevelOptions = (): { value: HierarchicalLevelEnum; label: string }[] => {
  const keys = Object.keys(HierarchicalLevelEnum).filter(
    (key: string) => typeof HierarchicalLevelEnum[key as keyof typeof HierarchicalLevelEnum] === "string",
  );
  return keys.map((val) => {
    const value = HierarchicalLevelEnum[val as keyof typeof HierarchicalLevelEnum];
    return { label: getHierarchicalLevelLabel(value), value };
  });
};
